export const environment = {
  production: false,
  useMobileOnly: false,
  //baseUrl: 'http://10.10.10.107//GuestsServices',
   monitoringB: false
};
